import { Link } from "react-router-dom";

export default function ArticleCTA() {
  return (
    <section className="w-full py-16 md:py-24 px-4 md:px-8 bg-background-50">
      <div className="max-w-4xl mx-auto">
        <div className="relative rounded-3xl overflow-hidden bg-gradient-to-br from-primary-500 via-primary-600 to-primary-800 p-8 md:p-12">
          <div className="absolute top-0 right-0 w-64 h-64 opacity-10">
            <div className="w-full h-full rounded-full bg-background-50 blur-3xl transform translate-x-1/3 -translate-y-1/3"></div>
          </div>

          <div className="relative z-10 flex flex-col md:flex-row items-center gap-8">
            <div className="flex-1 text-center md:text-left">
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-background-50/20 text-background-50 text-xs font-medium mb-4">
                <i className="ri-article-line"></i>
                <span className="whitespace-nowrap">SEO Resource</span>
              </div>
              <h2 className="text-xl md:text-3xl font-heading font-bold text-background-50 mb-3">
                Vigorbuy Spreadsheet Complete Guide
              </h2>
              <p className="text-sm md:text-base text-background-100/80 leading-relaxed max-w-lg">
                Dive deep into our comprehensive beginner guide covering everything you need to know about navigating the Vigorbuy spreadsheet — from category exploration to safety tips, product research strategies, and expert shopping advice.
              </p>
            </div>

            <div className="flex-shrink-0">
              <Link
                to="/article/vigorbuy-spreadsheet-complete-guide"
                className="inline-flex items-center gap-2 px-7 py-3.5 rounded-xl bg-background-50 text-primary-600 text-sm md:text-base font-semibold hover:bg-background-100 transition-all duration-200 cursor-pointer whitespace-nowrap no-underline shadow-lg"
              >
                <i className="ri-book-open-line text-lg"></i>
                <span>Read Full Guide</span>
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}